class WishlistManager {
  constructor() {
    this.storageKey = 'handmade_wishlist';
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateWishlistButtons();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[class*="product-card-wishlist-btn"]');
      if (button) {
        e.preventDefault();
        e.stopPropagation();
        const productId = button.dataset.productId;
        const productHandle = button.dataset.productHandle;
        this.toggleWishlist(productId, productHandle);
      }
    });

    // Listen for filter changes on collection pages to update new product cards
    window.addEventListener('filterChange', () => {
      this.updateWishlistButtons();
    });
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error('Error reading wishlist from localStorage:', error);
      return [];
    }
  }

  saveWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    } catch (error) {
      console.error('Error saving wishlist to localStorage:', error);
    }
  }

  isInWishlist(productId) {
    if (!productId) return false;
    const wishlist = this.getWishlist();
    return wishlist.some(item => {
      if (typeof item === 'string') return item === productId.toString();
      return item.id === productId.toString();
    });
  }

  addToWishlist(productId, productHandle) {
    if (!productId) return false;
    const wishlist = this.getWishlist();
    if (!this.isInWishlist(productId)) {
      wishlist.push({ id: productId.toString(), handle: productHandle });
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  }

  removeFromWishlist(productId) {
    if (!productId) return false;
    const wishlist = this.getWishlist();
    const index = wishlist.findIndex(item => {
      if (typeof item === 'string') return item === productId.toString();
      return item.id === productId.toString();
    });
    if (index > -1) {
      wishlist.splice(index, 1);
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  }

  toggleWishlist(productId, productHandle) {
    if (this.isInWishlist(productId)) {
      this.removeFromWishlist(productId);
    } else {
      this.addToWishlist(productId, productHandle);
    }
    // Update all buttons to ensure UI consistency across multiple instances of the same product
    this.updateWishlistButtons();

    // Trigger custom event for wishlist page to refresh
    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: {
        productId: productId,
        wishlist: this.getWishlist()
      }
    }));
  }

  updateWishlistButtons() {
    const buttons = document.querySelectorAll('[class*="product-card-wishlist-btn"]');
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      if (this.isInWishlist(productId)) {
        button.classList.add('active');
        button.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  getWishlistCount() {
    return this.getWishlist().length;
  }

  clearWishlist() {
    this.saveWishlist([]);
    this.updateWishlistButtons();
  }
}

class ProductCardCartManager {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(e) {
    if (!e.target.matches('.\\#product-card-add-form')) return;

    e.preventDefault();
    const form = e.target;
    const button = form.querySelector('.\\#product-card-add-btn');

    this.addToCart(form, button);
  }

  addToCart(form, button) {
    this.setLoading(button, true);

    const formData = new FormData(form);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Dispatch updateCart event which the theme listens to (in modal.js)
        document.dispatchEvent(new CustomEvent('updateCart', {
          bubbles: true,
          detail: {
            callback: () => {
              this.setLoading(button, false);
              // Dispatch openPopup to open the cart drawer
              document.dispatchEvent(new CustomEvent('openPopup', {
                bubbles: true,
                detail: {
                  target: 'CART'
                }
              }));
            }
          }
        }));
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        this.setLoading(button, false);
      });
  }

  setLoading(button, isLoading) {
    const textSpan = button.querySelector('.\\#product-card-add-btn-text');
    const spinnerSpan = button.querySelector('.\\#product-card-add-btn-spinner');

    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      if (textSpan) textSpan.hidden = true;
      if (spinnerSpan) spinnerSpan.hidden = false;
    } else {
      button.removeAttribute('disabled');
      if (textSpan) textSpan.hidden = false;
      if (spinnerSpan) spinnerSpan.hidden = true;
    }
  }
}

// Initialize both managers once
function initProductCardManagers() {
  if (!window.wishlistManager) window.wishlistManager = new WishlistManager();
  if (!window.productCardCartManager) window.productCardCartManager = new ProductCardCartManager();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCardManagers);
} else {
  initProductCardManagers();
}